import { shallowRef } from 'vue';

const activeCall = shallowRef(null);
const callSheetOpen = shallowRef(false);

export class CallSheetService {
  static get active() {
    return activeCall;
  }

  static get isOpen() {
    return callSheetOpen;
  }

  // The call stays available while the sheet animates closed.
  static open(call) {
    activeCall.value = call;
    callSheetOpen.value = true;
  }

  static close() {
    callSheetOpen.value = false;
  }

  static reset() {
    callSheetOpen.value = false;
    activeCall.value = null;
  }
}
